import createPalette from '@mui/material/styles/createPalette';

const acmeMainPalette = {
  primary: {
    main: '#c68700',
  },
  secondary: {
    main: '#532205',
  },
  kortxAccentBlue: {
    light: '#FFF8E0',
    main: '#330000',
  },
  kortxAccentGreen: {
    light: '#E0F9ED',
    main: '#09D898',
  },
  kortxAccentMagenta: {
    light: '#F7E2ED',
    main: '#D63384',
  },
  kortxAccentYellow: {
    light: '#FFF8E0',
    main: '#FECD00',
  },
};

export const acmeLightPalette = createPalette(acmeMainPalette);

export const acmeDarkPalette = createPalette({
  ...acmeMainPalette,
  mode: 'dark',
});

export const acmeChartPalette: string[] = [
  '#c68700',
  '#330000',
  '#6366F1',
  '#FBBF24',
  '#4ADE80',
  '#334659',
  '#D946EF',
];
